var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.339 13.333v-10H1.672V1.666h2.5c.46 0 .833.373.833.833v10h10.366l1.666-6.666H6.672V4.166h11.433a.833.833 0 0 1 .808 1.035l-2.083 8.334a.83.83 0 0 1-.809.631H4.171a.833.833 0 0 1-.832-.833m1.666 5.833a1.667 1.667 0 1 1 0-3.333 1.667 1.667 0 0 1 0 3.333m10 0a1.667 1.667 0 1 1 0-3.333 1.667 1.667 0 0 1 0 3.333"
  })));
};
export default SvgCart;